import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tabs, Tab, withStyles, useTheme } from '@material-ui/core';
import {Icon } from '@material-ui/core';

import { PaneContext } from '../../../contexts/PaneContext';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function FullWidthTabs({ data, colour }) {
  const { activeTab, changeTab, newPatronMode } = useContext(PaneContext);
  const { palette } = useTheme();

  const StyledTabs = withStyles({
    indicator: {
      display: 'none',
    },
  })(Tabs);

  const StyledTab = withStyles((theme) => ({
    root: {
      color: theme.palette.text.disabled,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: '1.8rem',
      textTransform: 'uppercase',
      marginRight: theme.spacing(1),
      minWidth: 0,
      '&:focus': {
        opacity: 1,
      },
    },
    selected: {
      color:
        !colour || colour === 'text'
          ? theme.palette.text.primary
          : theme.palette[colour].main,
    },
    labelIcon: {
      minHeight: 0,
    },
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  }))(Tab);

  const handleChange = (event, newValue) => {
    changeTab(newValue);
  };

  return (
    <Container>
      <TabBar
        colour={
          !colour || colour === 'text'
            ? palette.text.primary
            : palette[colour].main
        }
      >
        <StyledTabs
          value={activeTab}
          onChange={handleChange}
          variant='scrollable'
          aria-label='admin panels'
        >
          {data.map(({ title, icon, index }) => (
            <StyledTab
              key={title}
              label={title}
              disabled={newPatronMode && title !== 'Order'}
              icon={
                <Icon icon={icon} style={{ marginRight: '1rem' }} />
              }
              {...a11yProps(index)}
            />
          ))}
        </StyledTabs>
      </TabBar>
      {data.map(({ index, component }) => (
        <TabPanel key={index} value={activeTab} index={index}>
          {component}
        </TabPanel>
      ))}
    </Container>
  );
}

const Container = styled.div``;

const TabBar = styled.div`
  border-bottom: 1px solid ${(props) => props.colour};
`;

FullWidthTabs.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
};
